export default __webpack_public_path__ + "static/media/icons8-smoke.34268a44.svg";